import { css } from 'styled-components';
import { themeGet } from '../../../foundation/theme/themeGet/get.js';

function getStylesBySelected() {
  return css(["background-color:", ";color:", ";&:disabled{background-color:", ";color:", ";}"], themeGet('colors.primary.50'), themeGet('colors.text.300'), themeGet('colors.disabled.100'), themeGet('colors.disabled.200'));
}

export { getStylesBySelected };
